import React from 'react';
import PropTypes from 'prop-types';
import PortalModal from '../../common/Modal/PortalModal';
import GenericButton from '../../common/GenericButton';

const modalStyles = {
  left: '40%',
  top: '30%',
  width: '334px',
  height: '191px,',
};

const ACDefinitionFolderDeleteModal = props => {
  const { folder, show, deleteHandler, closeHandler } = props;
  return (
    <div style={{ position: 'center' }} className="delete-modal">
      <PortalModal
        title="Delete"
        isShowing={show}
        dialogStyles={modalStyles}
        onCloseClicked={closeHandler}
      >
        Do you want to delete{' '}
        {folder.length > 1
          ? ` ${folder.length} definitions`
          : folder.title || folder.folderName}
        ?
        <span style={{ whiteSpace: 'pre-line' }}>
          {'\n'}
          {'\n'}
        </span>
        <div className="text-center">
          <span className="pull-left">
            <GenericButton
              name="Cancel"
              btnStyle="cancel-button"
              onBtnClick={closeHandler}
            />
          </span>
          <span className="pull-right">
            <GenericButton
              name="Confirm"
              btnStyle="confirm-button"
              onBtnClick={deleteHandler}
            />
          </span>
          <span style={{ whiteSpace: 'pre-line' }}>
            {'\n'}
            {'\n'}
          </span>
        </div>
      </PortalModal>
    </div>
  );
};

ACDefinitionFolderDeleteModal.propTypes = {
  folder: PropTypes.shape({
    folderName: PropTypes.string,
    title: PropTypes.string,
  }),
  show: PropTypes.bool,
  deleteHandler: PropTypes.func,
  closeHandler: PropTypes.func,
};

export default ACDefinitionFolderDeleteModal;

// folder[0].title || folder[0].folderName;
